<template>
    <div class="wrapper">
        <app-video
            v-if="appVideoInfo && appVideoInfo.video"
            :poster="appVideoInfo.poster"
            :src="appVideoInfo.video"
            :app-video-info="appVideoInfo"
        />
        <div v-else class="swiper-wrapper">
            <swiper
                class="img-list-swiper"
                :options="swiperOptions"
            >
                <swiper-slide
                    v-for="(item, index) in imgs"
                    :key="item + '-' + index"
                    class="img-item"
                >
                    <img :src="item" alt="">
                </swiper-slide>
            </swiper>
            <div class="dot-wrapper" v-if="imgs.length > 1">
                <div
                    v-for="(item, index) in imgs"
                    :key="index"
                    class="dot-item"
                    :class="{'active': index === currentSwiperIndex}"
                ></div>
            </div>
        </div>
    </div>
</template>

<script>
import AppVideo from './app-video';
import {Swiper, SwiperSlide} from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
export default {
    components: {
        AppVideo,
        Swiper,
        SwiperSlide,
    },
    props: {
        appVideoInfo: {
            type: Object,
            default: null,
        },
        imgs: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            swiperOptions: {
                onSlideChangeEnd: swiper => {
                    this.currentSwiperIndex = swiper.realIndex;
                },
            },
            currentSwiperIndex: 0,
        };
    },
};
</script>

<style lang="scss" scoped>
@import "~@/common/style/mixin/utils";
@import "~@/common/style/mixin/border";
@import "~@/common/style/mixin/mixins";
$design-width: 1242;

.swiper-wrapper {
    position: relative;
    .img-item {
        width: 100%;
        img {
            width: 100%;
            height: auto;
            max-height: px2rem(699);
            object-fit: cover;
        }
    }
    .dot-wrapper {
        z-index: 2;
        position: absolute;
        bottom: px2rem(24);
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        .dot-item {
            width: px2rem(15);
            height: px2rem(15);
            border-radius: 50%;
            background-color: #fff;
            opacity: .36;
            margin-right: px2rem(15);
            &.active {
                opacity: 1;
            }
        }
    }
}

</style>